import { useTranslation } from "react-i18next";
import { useStorageObject } from "../../app/state/storageObjectSlice/hook/use-storage-object";
import { useServiceNavigate } from "../../app/state/storageObjectSlice/hook/use-service-navigate";
import { Sidebar } from "../../common/AppSidebar";
import { UploadFileMethodModal } from "../../features/Files/Components/UploadFileMethodModal";
import { useAppModals } from "../../app/state/modalSlice/hook/use-app-modals";
import { SafeOutlet } from "../../common/Protectors/SafeOutlet";
import styles from "./styles.module.css";
import { useStorageSelectors } from "../../app/state/storageObjectSlice/hook/use-storage-selectors";

export const FilesPage = () => {
  const { menuItems, selectedObject, isLoading, currentService } =
    useStorageSelectors("userfiles");
  const { addObject, handleSelectObject } = useStorageObject(
    "userfiles",
    "userfiles",
    currentService,
  );
  const { handleOpenModal } = useAppModals();
  const { t } = useTranslation();

  useServiceNavigate("userfiles", "userfiles");

  return (
    <div className={styles["page-layout"]}>
      <Sidebar
        menuItems={menuItems}
        onAdd={() => handleOpenModal("upload_file_method_modal", null)}
        onSelect={handleSelectObject}
        selectedId={selectedObject?.id ?? ""}
        service={"userfiles"}
        isLoading={isLoading ?? false}
        defaultName={t("userfiles.default_folder_name")}
        customCreateObject={() =>
          handleOpenModal("upload_file_method_modal", {
            id: selectedObject?.id ?? "",
            value: "",
          })
        }
      />
      {selectedObject && <SafeOutlet />}
      <UploadFileMethodModal />
    </div>
  );
};
